import axios from "axios";
import { API } from "./api";

// Separate axios client for B2B (businesses) so it doesn't share JWT with regular users.
export const bizApi = axios.create({ baseURL: API });

bizApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("tm_biz_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

bizApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("tm_biz_token");
      localStorage.removeItem("tm_biz");
    }
    return Promise.reject(err);
  }
);

export const saveBiz = (token, biz) => {
  localStorage.setItem("tm_biz_token", token);
  localStorage.setItem("tm_biz", JSON.stringify(biz));
};

export const loadBiz = () => {
  try {
    const raw = localStorage.getItem("tm_biz");
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

export const clearBiz = () => {
  localStorage.removeItem("tm_biz_token");
  localStorage.removeItem("tm_biz");
};
